export default {
  namespaced: true,
  state: {
    trainIsTransfer: false, //火车票是否是中转
    transferListRefresh: false, //是否重新刷新中转列表
    trainDetailInfo: {}, //火车中转列表进入1.5详情数据
  },
  mutations: {
    // 切换tab存储是否中转
    setTrainIsTransfer(state, data) {
      state.trainIsTransfer = data;
    },
    // 1.5无票返回中转列表要刷新
    setTransferListRefresh(state, data) {
      state.transferListRefresh = data;
    },
    // 存储火车票详情信息
    setTrainDetailInfo(state, data) {
      state.trainDetailInfo = data || {};
    },
  },
  actions: {},
};
